import Calculation from '../../../types/api/calculation'
import CalculationPosition from '../../../types/api/calculation-position'

export type DataSourceItem = Calculation | (CalculationPosition & { calculation: Calculation })

type RowSource =
    | { type: 'calculation'; calc: Calculation }
    | { type: 'position'; position: CalculationPosition; calc: Calculation }

function getRowSources(calculations: Calculation[]): RowSource[] {
    const sources: RowSource[] = []
    for (const calc of calculations) {
        sources.push({ type: 'calculation', calc })
        for (const position of calc.calculation_positions ?? []) {
            sources.push({ type: 'position', position, calc })
        }
    }
    return sources
}

/**
 * Строит dataSource с переиспользованием ссылок на строки из previousDataSource,
 * если соответствующая запись (calculation/position) не изменилась по ссылке.
 * Это уменьшает ререндеры таблицы при обновлении одной позиции.
 */
export function buildDataSourceWithSharing(
    currentCalculations: Calculation[],
    previousCalculations: Calculation[] | null,
    previousDataSource: DataSourceItem[]
): DataSourceItem[] {
    const currentSources = getRowSources(currentCalculations)
    const previousSources = previousCalculations !== null ? getRowSources(previousCalculations) : []

    const result: DataSourceItem[] = []

    for (let i = 0; i < currentSources.length; i++) {
        const curr = currentSources[i]

        if (curr.type === 'calculation') {
            result.push(curr.calc)
            continue
        }

        const prev = previousSources[i]
        const prevRow = previousDataSource[i]

        const canReuse =
            prev?.type === 'position' &&
            prevRow != null &&
            prev.position === curr.position &&
            prev.calc === curr.calc

        if (canReuse) {
            result.push(prevRow)
        } else {
            result.push({ ...curr.position, calculation: curr.calc })
        }
    }

    return result
}

export default function convertCalculationsToDataSource(
    calculations: Calculation[]
): DataSourceItem[] {
    return calculations.reduce((acc: (Calculation | CalculationPosition)[], calc) => {
        acc.push(calc)

        calc.calculation_positions?.forEach(position => {
            acc.push({ ...position, calculation: calc })
        })

        return acc
    }, [])
}
